@if ((loadingService.loadingIndicator$ | async) === 0) {
  <div id="app-customer" class="main-container flex-column d-flex p-2 p-md-3" role="main"
    [attr.aria-label]="('CUSTOMERPAGE' | translate)">
    <!-- Navbar for Top Bar Links with Hamburger Menu for Mobile -->
    <!-- TODO: if was defaultStoreString === 'store' but that does not seemed right, and store was removed anyways -->
    @if (false) {
      <nav [attr.aria-label]="('MAINNAVIGATION' | translate)" class="navbar navbar-expand-lg navbar-light w-100"
        >
        <div class="container-fluid">
          <!-- Hamburger Menu Button aligned to the right -->
          <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="dropdown" aria-expanded="false"
            [attr.aria-label]="('TOGGLENAVIGATION' | translate)">
            <span class="navbar-toggler-icon"></span>
          </button>
          <!-- Dropdown Menu -->
          <ul class="dropdown-menu dropdown-menu-end">
            @if (languageService.getLanguage() !== 'de') {
              <li><app-link (click)="setLanguage('de')"
                [title]="('DE' | translate)" [style]="'dropdown'"><img class="small-flag" [width]="15" [height]="11"
              [ngSrc]="'/assets/images/flags/de.svg'" [alt]="'DE' | translate" appNgSrcImageError /></app-link></li>
            }
            @if (languageService.getLanguage() !== 'en') {
              <li><app-link (click)="setLanguage('en')"
                [title]="('EN' | translate)" [style]="'dropdown'"><img class="small-flag" [width]="15" [height]="11"
              [ngSrc]="'/assets/images/flags/en.svg'" [alt]="'EN' | translate" appNgSrcImageError /></app-link></li>
            }
            <li><app-link [href]="'/auth/registration'" [title]="('TOCUSTOMERREGISTRATION' | translate)"
            [style]="'dropdown'">{{ ('TOCUSTOMERREGISTRATION' | translate) }}</app-link></li>
          </ul>
          <!-- Navbar Links for Desktop View -->
          <div class="collapse navbar-collapse justify-content-end">
            <ul class="navbar-nav d-none d-lg-flex">
              @if (languageService.getLanguage() !== 'de') {
                <li class="nav-item"><app-link (click)="setLanguage('de')"
                  [title]="('DE' | translate)" [style]="'nav'"><img class="small-flag" [width]="15" [height]="11"
                [ngSrc]="'/assets/images/flags/de.svg'" [alt]="'DE' | translate" appNgSrcImageError /></app-link></li>
              }
              @if (languageService.getLanguage() !== 'en') {
                <li class="nav-item"><app-link (click)="setLanguage('en')"
                  [title]="('EN' | translate)" [style]="'nav'"><img class="small-flag" [width]="15" [height]="11"
                [ngSrc]="'/assets/images/flags/en.svg'" [alt]="'EN' | translate" appNgSrcImageError /></app-link></li>
              }
              <li class="nav-item"><app-link [href]="'/auth/registration'"
                [title]="('TOCUSTOMERREGISTRATION' | translate)" [style]="'nav'">{{ ('TOCUSTOMERREGISTRATION' |
              translate) }}</app-link></li>
            </ul>
          </div>
        </div>
      </nav>
    }
    <div class="inner-container w-100 h-100 d-flex flex-column flex-lg-row overflow-hidden custom-scrollbar">
      <!-- Left Column for Logo -->
      <div class="col-lg-6 col-md-12 d-flex flex-column justify-content-center align-items-center p-3 logo">
        @if (layoutService.getLogoByTheme()) {
          <img
            [ngSrc]="layoutService.getLogoByTheme()"
            [width]="300" [height]="107" [alt]="('HSIMAGE' | translate)" disableOptimizedSrcset priority
            class="img-fluid" appNgSrcImageError />
        }
      </div>
      <!-- Right Column for Form -->
      <div class="col-lg-6 col-md-12 d-flex flex-column justify-content-center align-items-center custom-scrollbar">
        <div class="scroll-wrapper w-100 p-3">
          <form class="form-container w-100 mx-auto" [attr.aria-label]="('CUSTOMERKEY' | translate)" novalidate>
            <div class="mb-2">
              <app-headline [type]="'h5'" [title]="('CUSTOMERKEY' | translate)"></app-headline>
            </div>
            <div class="mb-3"><app-content [fontSize]="'fs-small'">{{ "CUSTOMERHINT" | translate }}</app-content></div>
            <!-- Form Inputs -->
            <div class="mb-3">
              <app-form-input [placeholder]="('CUSTOMERKEY' | translate)" [label]="('CUSTOMERKEY' | translate)"
                [errorText]="('CUSTOMERKEYREQUIRED' | translate)" [iconFront]="'person'" [fCN]="'customer'"
                [fG]="customerForm"
              (returnKeyPress)="onCustomerLogin(customerForm.controls['customer'].value)"></app-form-input>
            </div>
            <app-form-button [text]="'LOGIN' | translate" [disabled]="customerForm.invalid"
              (click)="onCustomerLogin(customerForm.controls['customer'].value)"
            [cssClass]="'e-primary e-block w-100'"></app-form-button>
          </form>
        </div>
      </div>
    </div>
  </div>
}
